// extracted by mini-css-extract-plugin
export default {"shortener":"Shortener_shortener__M5Du9","form":"Shortener_form__t-jfd","input":"Shortener_input__Tj0OK","field":"Shortener_field__0-nKF","error":"Shortener_error__FU9fH"};